import { render, staticRenderFns } from "./_formCategorySection.vue?vue&type=template&id=5787dcc4&scoped=true&"
import script from "./_formCategorySection.vue?vue&type=script&lang=js&"
export * from "./_formCategorySection.vue?vue&type=script&lang=js&"
import style0 from "./_formCategorySection.vue?vue&type=style&index=0&id=5787dcc4&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5787dcc4",
  null
  
)

export default component.exports